<div class="uni-overlay active" id="uniOverlay">
  <div class="uni-modal">
    <div class="uni-modal-header pd-30" id="uniHeader">
      Órdenes por confirmar
    </div>
    <div class="uni-modal-body">
      <div class="uni-step active">
        <div class="uni-prizes-container ">
          <p class="uni-prizes-text">
            Recientemente se entregaron los siguientes premios, selecciona si ya lo recibiste:
          </p>
          <div class="selected-onboarding-modal-container">
            @for (order of ordersByConfirm(); track order.orderDetailId) {
            <div class="selected-onboarding-modal-card">
              <div class="selected-onboarding-modal-img">
                <img [src]="order.pathImage" [alt]="'Premio ' + order.orderNumber" class="uni-prize-img">
              </div>
              <div class="selected-onboarding-modal-content">
                <h3 class="selected-onboarding-modal-title">{{ order.description }}</h3>
                <p class="selected-onboarding-modal-subtitle">N° Canje {{ order.orderNumber }}</p>
              </div>
              <div class="selected-onboarding-modal-check">
                <label class="selected-onboarding-modal-checkbox-wrapper">
                  <input type="checkbox" class="selected-onboarding-modal-checkbox-input" [value]="order.orderDetailId"
                    (change)="toggleArticle(order.orderDetailId, $event)">
                  <span class="selected-onboarding-modal-checkbox-custom"></span>
                </label>
              </div>
            </div>
            }
          </div>
          <!-- <p class="text-center">
            ¿No recibiste tus articulos? <br>
            <a href="#!">Da clic aquí</a>
          </p> -->

          @if(!isAnyConfirm()) {
          <p class="text-bg-danger mb-2 rounded-3 text-center fw-bold">
            Confirma al menos un artículos para continuar
          </p>
          }
        </div>
      </div>

      <div class="uni-modal-footer">
        <button class="uni-btn uni-btn-next" (click)="confirmOrders()">Confirmar</button>
        <button class="uni-btn uni-btn-prev" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </div>